const FORCED_ROUTES = ['/', '/ajustes', '/login', '/logout', '/recuperar', '/iconos']

export default FORCED_ROUTES
